module.exports = __webpack_public_path__ + "img/1f565b7.png";